import './top.scss'
import { EventBus } from 'js/utility/event-bus.js'

export default {
    name: 'top',

    data: {
        intObserver: null,
        position: 'top'
    },

    mounted () {
        const placeholder = document.querySelector('.top__placeholder')
        this.intObserver = new IntersectionObserver(entries => {
            if (entries && entries.length) {
                if (entries[0].isIntersecting && this.position !== 'top') {
                    this.position = 'top'
                }
                if ((!entries[0].isIntersecting) && this.position !== 'fixed') {
                    this.position = 'fixed'
                }
            }
        })
        this.intObserver.observe(placeholder)
    },

    methods: {
        toggleMobileNav () {
            EventBus.$emit('MobileMenu.toggle')
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/top/top.js